import React, {useRef} from "react";
import { InView } from "react-intersection-observer";

import CardText from "./card/CardText";
import CardToggle from "./card/CardToggle";
import CardVideo from "./card/CardVideo";
import CardVimeo from "./card/CardVimeo";
import CardYoutube from "./card/CardYoutube";
import CardAudio from "./card/CardAudio";
import CardLink from "./card/CardLink";
import CardLinkMap from "./card/CardLinkMap";
import CardTextEmpty from "./card/CardTextEmpty";
import TextLong from "./TextLong";
import TextLongAfter from "./TextLongAfter";
import TextImage from "./TextImage";
import TextImageEnd from "./TextImage";
import TextTitle from "./TextTitle";
import CompareSlider from "./CompareSlider";
import ImageCaption from "./ImageCaption";
import Audio from "./Audio";
import TextToggle from "./TextToggle";
import MultipleImages from "./MultipleImages";
import TextVideo from "./TextVideo";
import TextVideoControls from "./TextVideoControls";
import TextYoutube from "./TextYoutube";
import TextIframe from "./TextIframe";
import Share from "./Share";



export default function Card({
  slidesContent,
  callbackFromParent,
}) {

  const SLIDES = slidesContent;
  const ref= useRef();
  
  const width = window.innerWidth;
  const height = window.innerHeight;

  const narrativeWrapperStyle = {
    fontSize: 10,
    color: "white",
    position: "absolute",
    zIndex: 30,
    maxWidth: "100vw"
  };

  const narrativeElementStyle = {
    height: "auto",
    maxWidth: "100vw",
    minHeight: "100vh",
    //outline: "#4CAF50 solid 10px",
    position: "relative",
  };

  const cardWrapperStyle = {
    minHeight: "100vh",
    height: "auto",
    maxWidth: "100vw",
  };

  const cardStyle = {
    backgroundColor: "black",
    borderRadius: '10px 10px 10px 10px',
    width: "25vw",
    margin: `15px 15px 15px 10vw`,
    padding: '2px 10px 10px 15px',
    opacity: 0.85,
    zIndex: 90,
    //top: 500,
    position: "relative",
  };

  const emptyCardStyle = {
    width: "0vw",
    position: "relative",
    zIndex: 90,
    //top: 500,
  };

  return (
    <div style={narrativeWrapperStyle} id={"narrative-wrapper-slide"}>
      {Object.entries(SLIDES).map(([key, value]) => {
        const index = parseInt(key);
        //console.log(index);

        return (
          <>
            <InView
              key={`scroller-slide-${value.index}`}
              initialInView={true}
              threshold={0.5}
              onChange={(inView, ref, entry) => {
                if (inView) {
                  //console.log("switching to", value.index);
                }
                inView && callbackFromParent(value.index);
              }}
            >
              {({ ref, inView, entry }) => (   
                <div
                  key={index}
                  style={narrativeElementStyle}
                >
                  <div
                    id={"track-div-" + (index + 1).toString()}
                    ref={ref}
                    style={{
                      //width: "100%",
                      //height: "1%",
                      // backgroundColor: "white",
                    }}
                  />
                  {slidesContent[index].emptyCard ? (
                     <div
                     style={cardWrapperStyle}
                     id={"mobile-card-wrapper-" + (index + 1).toString()}
                    >
                       <div
                      style={emptyCardStyle}
                      id={"mobile-card-container-" + (index + 1).toString()}
                    >
                   <CardTextEmpty 
                      text={slidesContent[index].emptyCard}
                      isMobile={false} 
                      />
                    </div>
                    </div>
                  )
                  :null}
                  {slidesContent[index].contentCard ? (
                    <div
                       style={cardWrapperStyle}
                       id={"mobile-card-container-" + (index + 1).toString()}
                    >
                    <div
                      style={cardStyle}
                      id={"mobile-card-container-" + (index + 1).toString()}
                    >
                      <h3>
                        <font size="3">
                          {" "}
                          {slidesContent[index]
                            ? slidesContent[index].info
                            : "error: no slide number"}
                        </font>
                      </h3>
                      <CardText 
                      text={slidesContent[index].contentCard}
                      isMobile={false} 
                      />
                      <CardToggle
                        toggleTitle={slidesContent[index].toggleTitle}
                        toggleContent={slidesContent[index].toggleContent}
                      />
                      <CardVideo
                        src={slidesContent[index].inSlideVideoPlayer}
                      />
                      <CardVimeo
                        src={slidesContent[index].inSlideVimeoPlayer}
                      />
                      <CardYoutube
                        src={slidesContent[index].inSlideYoutubePlayer}
                      />
                      <CardAudio
                        src={slidesContent[index].inSlideAudioPlayer}
                      />
                      <CardLink src={slidesContent[index].inSlideLink} />
                      <CardLinkMap src={slidesContent[index].inSlideLinkMap} />
                    </div>
                    </div>
                  ) : null}
                  {slidesContent[index].textImage ? (
                  <TextImage
                    src={slidesContent[index].textImage}
                    isMobile={false}
                  />) : null }
                  {slidesContent[index].textLong ? (
                  <TextLong
                    textLong={slidesContent[index].textLong}
                    isMobile={false}
                  />) : null }
                   {slidesContent[index].textIframe ? (
                  <TextIframe
                    src={slidesContent[index].textIframe}
                    isMobile={false}
                  />) : null }
                     {slidesContent[index].textTitle ? (
                  <TextTitle
                    textTitle={slidesContent[index].textTitle}
                    isMobile={false}
                  />) : null }
                  {slidesContent[index].audio ? (
                  <Audio
                    src={slidesContent[index].audio}
                    isMobile={false}
                  />) : null }
                  {slidesContent[index].textToggleTitle ? (
                  <TextToggle
                  textToggleTitle={slidesContent[index].textToggleTitle}
                  textToggleContent={slidesContent[index].textToggleContent}
                  isMobile={false}
                  />) : null }
                    {slidesContent[index].multipleImages ? (
                  <MultipleImages
                    multipleImages={slidesContent[index].multipleImages}
                    isMobile={false}
                  />) : null }
                   {slidesContent[index].compareSlider ? (
                  <CompareSlider
                    compareSlider={slidesContent[index].compareSlider}
                    isMobile={false}
                  />) : null }
                  {slidesContent[index].textVideo ? (
                  <TextVideo
                    textVideo={slidesContent[index].textVideo}
                    isMobile={false}
                  />) : null }
                  {slidesContent[index].textVideoControls ? (
                  <TextVideoControls
                    textVideoControls={slidesContent[index].textVideoControls}
                    isMobile={false}
                  />) : null }
                  {slidesContent[index].imageCaption ? (
                  <ImageCaption
                    imageCaption={slidesContent[index].imageCaption}
                    isMobile={false}
                  />) : null }
                  {slidesContent[index].share ? (
                  <Share
                    src={slidesContent[index].share}
                    isMobile={false}
                  />) : null }
                  {slidesContent[index].textLongAfter ? (
                  <TextLongAfter
                  textLongAfter={slidesContent[index].textLongAfter}
                  isMobile={false}
                  />) : null }
                   {slidesContent[index].textYoutube? (
                  <TextYoutube
                    src={slidesContent[index].textYoutube}
                    isMobile={false}
                  />) : null }
                  {slidesContent[index].textImageEnd ? (
                  <TextImageEnd
                    src={slidesContent[index].textImageEnd}
                    isMobile={false}
                  />) : null }
                </div>
              )}
            </InView>
          </>
        );
      })}
    </div>
  );
}

